// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var MM_proof_tree = require("./MM_proof_tree.bs.js");
var Expln_utils_data = require("../../rescript-utils/main/Expln_utils_data.bs.js");
var Belt_MutableStack = require("rescript/lib/js/belt_MutableStack.js");

function exprSrcToDto(src, exprToIdx) {
  var nodeToIdx = function (node) {
    var idx = Belt_HashMap.get(exprToIdx, MM_proof_tree.pnGetExpr(node));
    if (idx !== undefined) {
      return idx;
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "exprSrcToDto: cannot get idx by expr."
          },
          Error: new Error()
        };
  };
  if (typeof src === "number") {
    return /* VarType */0;
  }
  switch (src.TAG | 0) {
    case /* Hypothesis */0 :
        return {
                TAG: /* Hypothesis */0,
                label: src.label
              };
    case /* Assertion */1 :
        return {
                TAG: /* Assertion */1,
                args: src.args.map(nodeToIdx),
                label: src.frame.label
              };
    case /* AssertionWithErr */2 :
        return {
                TAG: /* AssertionWithErr */2,
                args: src.args.map(nodeToIdx),
                label: src.frame.label,
                err: src.err
              };
    
  }
}

function proofNodeToDto(node, exprToIdx) {
  return {
          expr: MM_proof_tree.pnGetExpr(node),
          parents: MM_proof_tree.pnGetEParents(node).map(function (__x) {
                return exprSrcToDto(__x, exprToIdx);
              }),
          proof: Belt_Option.map(MM_proof_tree.pnGetProof(node), (function (__x) {
                  return exprSrcToDto(__x, exprToIdx);
                })),
          dbg: Belt_Option.map(MM_proof_tree.pnGetDbg(node), (function (dbg) {
                  return {
                          exprStr: dbg.exprStr
                        };
                }))
        };
}

function collectAllExprs(tree, roots) {
  var nodesToProcess = Belt_MutableStack.make(undefined);
  MM_proof_tree.ptGetAllSyntaxProofs(tree).forEach(function (param) {
        Belt_MutableStack.push(nodesToProcess, param[1]);
      });
  roots.forEach(function (expr) {
        Belt_MutableStack.push(nodesToProcess, MM_proof_tree.ptGetNode(tree, expr));
      });
  var processedNodes = Belt_HashSet.make(100, MM_context.ExprHash);
  var res = Belt_HashMap.make(100, MM_context.ExprHash);
  var saveNodesFromSrc = function (src) {
    if (typeof src === "number") {
      return ;
    }
    switch (src.TAG | 0) {
      case /* Hypothesis */0 :
          return ;
      case /* Assertion */1 :
      case /* AssertionWithErr */2 :
          break;
      
    }
    src.args.forEach(function (arg) {
          Belt_MutableStack.push(nodesToProcess, arg);
        });
  };
  while(!Belt_MutableStack.isEmpty(nodesToProcess)) {
    var curNode = Belt_Option.getExn(Belt_MutableStack.pop(nodesToProcess));
    var curExpr = MM_proof_tree.pnGetExpr(curNode);
    if (!Belt_HashSet.has(processedNodes, curExpr)) {
      Belt_HashSet.add(processedNodes, curExpr);
      Belt_HashMap.set(res, curExpr, Belt_HashMap.size(res));
      MM_proof_tree.pnGetEParents(curNode).forEach(saveNodesFromSrc);
      Belt_Option.forEach(MM_proof_tree.pnGetProof(curNode), saveNodesFromSrc);
    }
    
  };
  return res;
}

function createSyntaxProofsDto(tree, exprToIdx, nodes) {
  return MM_proof_tree.ptGetAllSyntaxProofs(tree).map(function (param) {
              var idx = Belt_HashMap.get(exprToIdx, MM_proof_tree.pnGetExpr(param[1]));
              var tmp;
              if (idx !== undefined) {
                tmp = Caml_array.get(nodes, idx);
              } else {
                throw {
                      RE_EXN_ID: MM_parser.MmException,
                      _1: {
                        msg: "Could not convert proofNode to proofNodeDto for a syntax proof."
                      },
                      Error: new Error()
                    };
              }
              return [
                      param[0],
                      tmp
                    ];
            });
}

function proofTreeToDto(tree, rootStmts) {
  var exprToIdx = collectAllExprs(tree, rootStmts);
  var nodes = new Array(Belt_HashMap.size(exprToIdx));
  Belt_HashMap.forEach(exprToIdx, (function (expr, idx) {
          Caml_array.set(nodes, idx, proofNodeToDto(MM_proof_tree.ptGetNode(tree, expr), exprToIdx));
        }));
  return {
          newVars: MM_proof_tree.ptGetCopyOfNewVars(tree),
          disj: MM_proof_tree.ptGetDisj(tree),
          nodes: nodes,
          syntaxProofs: createSyntaxProofsDto(tree, exprToIdx, nodes),
          dbg: Belt_Option.map(MM_proof_tree.ptGetDbg(tree), (function (dbg) {
                  return {
                          newVars: dbg.newVars,
                          disj: dbg.disj
                        };
                }))
        };
}

function createProofTable(tree, root, essentialsOnlyOpt, ctx, param) {
  var essentialsOnly = essentialsOnlyOpt !== undefined ? essentialsOnlyOpt : false;
  if (essentialsOnly && Belt_Option.isNone(ctx)) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Error in createProofTable: ctx must be set when essentialsOnly == true."
          },
          Error: new Error()
        };
  }
  var filterArgs = function (args, label) {
    if (!(essentialsOnly && args.length > 0)) {
      return args;
    }
    var essentialArgs = [];
    MM_context.getFrameExn(Belt_Option.getExn(ctx), label).hyps.forEach(function (hyp, i) {
          if (hyp.typ === /* E */1) {
            essentialArgs.push(Caml_array.get(args, i));
            return ;
          }
          
        });
    return essentialArgs;
  };
  var exprToIdx = Belt_HashMap.make(64, MM_context.ExprHash);
  var tbl = [];
  var saveExprToTbl = function (expr, proof) {
    if (Belt_Option.isSome(Belt_HashMap.get(exprToIdx, expr))) {
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "getIdxByExpr(expr)->Belt_Option.isSome in createProofTable()."
            },
            Error: new Error()
          };
    }
    var idx = tbl.push({
          expr: expr,
          proof: proof
        }) - 1 | 0;
    Belt_HashMap.set(exprToIdx, expr, idx);
  };
  Expln_utils_data.traverseTree(undefined, root, (function (param, n) {
          var match = n.proof;
          if (match !== undefined) {
            if (typeof match === "number") {
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "VarType is not supported in createProofTable [1]."
                    },
                    Error: new Error()
                  };
            }
            switch (match.TAG | 0) {
              case /* Hypothesis */0 :
                  return ;
              case /* Assertion */1 :
                  return filterArgs(match.args, match.label).map(function (idx) {
                              return Caml_array.get(tree.nodes, idx);
                            });
              case /* AssertionWithErr */2 :
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "AssertionWithErr is not supported in createProofTable [1]."
                        },
                        Error: new Error()
                      };
              
            }
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Cannot create proofTable from an unproved proofNodeDto [1]."
                  },
                  Error: new Error()
                };
          }
        }), undefined, undefined, (function (param, n) {
          var match = n.proof;
          if (match !== undefined) {
            if (typeof match === "number") {
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "VarType is not supported in createProofTable [2]."
                    },
                    Error: new Error()
                  };
            }
            switch (match.TAG | 0) {
              case /* Hypothesis */0 :
                  if (Belt_Option.isNone(Belt_HashMap.get(exprToIdx, n.expr))) {
                    saveExprToTbl(n.expr, {
                          TAG: /* Hypothesis */0,
                          label: match.label
                        });
                  }
                  break;
              case /* Assertion */1 :
                  var label = match.label;
                  if (Belt_Option.isNone(Belt_HashMap.get(exprToIdx, n.expr))) {
                    saveExprToTbl(n.expr, {
                          TAG: /* Assertion */1,
                          args: filterArgs(match.args, label).map(function (nodeIdx) {
                                var expr = Caml_array.get(tree.nodes, nodeIdx).expr;
                                var idx = Belt_HashMap.get(exprToIdx, expr);
                                if (idx !== undefined) {
                                  return idx;
                                }
                                throw {
                                      RE_EXN_ID: MM_parser.MmException,
                                      _1: {
                                        msg: "Could not determine idx by expr in createProofTable()."
                                      },
                                      Error: new Error()
                                    };
                              }),
                          label: label
                        });
                  }
                  break;
              case /* AssertionWithErr */2 :
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "AssertionWithErr is not supported in createProofTable [2]."
                        },
                        Error: new Error()
                      };
              
            }
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Cannot create proofTable from an unproved proofNodeDto [2]."
                  },
                  Error: new Error()
                };
          }
        }), undefined);
  return tbl;
}

exports.proofTreeToDto = proofTreeToDto;
exports.createProofTable = createProofTable;
/* MM_context Not a pure module */
